// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';

// Imports DIAN  
import { DLogger } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DReteFuente350Servicios, DConceptoPago, DItemConcepto, DTarifaRetencionActEconomica } from '@dian-api/rtefte350';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DActividadEconomica } from '@dian/api-rut/src/to/actividad-economica/dactividad-economica'; 
import { DDiligenciamientoParametricasServicios } from '@dian/api-diligenciamiento';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';
import { DArchivoBlob } from '@dian/api-formulario';

// Imports App
import { DFormularioConfiguracion } from '../../../configuracion/dformulario-configuracion';
import { DPreguntasFormulario } from '../../../configuracion/dpreguntas-formulario';
import { DAyudasFormulario } from '../../../configuracion/dayudas-formulario';


@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio, 
    DUtilidadesFormularioServicio,       
    DReteFuente350Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DReciboPagoDialogoServicio,
    DContextoUsuarioServicio
  ]
})
export class FormularioComponent extends DFormulario implements OnInit {

    private anioDeclaracion: Number;
    //slidders
    public cardDeclarante: boolean = true;   
    public cardConceptos: boolean = true;
    public cardRetencionesIVA: boolean = true;
    public declaranteAyuda: boolean = false;
    public conceptosAyuda: boolean = false;
    public retencionesAyuda: boolean = false;  
    //public habilitacion42y67: boolean = false; 
    public habilitacion67: boolean = false;

    public ayudasBaseFormulario: DAyudasFormulario;

    public listActividadesEconomicas: Array<DTarifaRetencionActEconomica>;  
    public actividadesEconomicas: DActividadesEconomicas;  
    public listConceptosCs50y75: Array<any>;
    public listConceptosCs51y76: Array<DConceptoPago>;
    public tarifaRetencion: DTarifaRetencionActEconomica;
    public mostrarConceptos: boolean = false;
    public mostrarArchivosCargadosBtn: boolean = false;
    
    /**
    * @constructor
    */
    constructor(
        dialog:MatDialog,
        router:Router,
        dNotificacionServicio:DNotificacionServicio,
        dPreguntasDialogoServicio: DPreguntasDialogoServicio,
        activatedRoute:ActivatedRoute,        
        dutilidades:DOperacionesMatematicasServicio,        
        utilitariosForm:DUtilidadesFormularioServicio,
        dlogger:DLogger,
        private dContextoUsuario: DContextoUsuarioServicio,
        private dRutServicios:DRutServicios,         
        private dServicioRESTAPI:DReteFuente350Servicios,  // Servicio de ejemplo (debe ser cambiado por el del api del formulario correspondiente),
        private dServiciosDiliParametricas:DDiligenciamientoParametricasServicios,
        private dReciboPago: DReciboPagoDialogoServicio,
        differ: KeyValueDiffers
    ) {
        super(
            router, 
            activatedRoute, 
            dialog,
            dContextoUsuario, 
            dNotificacionServicio, 
            dPreguntasDialogoServicio,
            dutilidades, 
            utilitariosForm, 
            dRutServicios, 
            dServicioRESTAPI, 
            new DFormularioConfiguracion(),
            new DPreguntasFormulario(),
            dlogger,
            differ,
            dServiciosDiliParametricas,
            dReciboPago
        );
        this.ayudasBaseFormulario = new DAyudasFormulario();  
        this.tarifaRetencion = new DTarifaRetencionActEconomica();
        this.actividadesEconomicas = new DActividadesEconomicas();
        this.listActividadesEconomicas = new Array<DTarifaRetencionActEconomica>();
        this.listConceptosCs50y75 = new Array<DConceptoPago>();
        this.listConceptosCs51y76 = new Array<DConceptoPago>();
    }

    /**
    * @desc Función para llamar todos los metodos que carguen los elementos del formulario
    * como tambien los datos del formulario
    */
    ngOnInit() {
        setTimeout(() => {            
            this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta                 
        }, 50);
        
        this.activatedRoute
            .queryParams
            .subscribe((params: Params) => {
                // si la carga no se hace por medio del metodo consultarFormulario
                if (!params.hasOwnProperty('idedocumento')) {
                    // validaciones adicionales
                }                                                            
            });
    }  

    /**
    * @implements Funcion que comunica desde la clase padre que el documento se ha cargado correctamente
    */
    protected onInitFormulario() {
        // Este metodo se ejecuta una vez la clase abstracta ha terminado su proceso y el formulario esta listo para ser diligenciado, aca se puede poner la logica que sea necesaria despues de que el formulario se encuentre listo        
      this.mostrarConceptos = true;
      //this.modelo.doc.cuerpo.cs_id_90 = "";
      //this.modelo.doc.cuerpo.cs_id_91 = "";
      this.obtenerActividadesEconomicas(this.modelo.doc.cab.cs_id_5);
      this.consultarActividadesEconomicasConTarifasRetencion(this.modelo.doc.cab.cs_id_1,this.modelo.doc.cab.cs_id_3);
      this.obtenerDVSignatario();

      if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
        this.modelo.doc.pie['cs_id_994'] = false;
      }        
    }  

    /**
    * @implements Funcion que comunica cuando el cuestionario ha sido contestado por si se requiere realizar alguna tarea adicional
    * @param {Any} respuestas
    */
    protected onInitCuestionario(respuestas:any) { 
      
    }

    /**
    * @implements Funcion que comunica cuando el modelo ha tenido un cambio
    * @param {Any} attrModelo
    */
    protected onChangeModelo(attrModelo:any) {
        //Implementacion de logica cuando el modelo cambia y no se ha guardado (se ocultan botones hasta que se vuelva a guardar)
    }

    /**
    * @implements Funcion que comunica cuando ha ocurrido algun evento el formulario
    * @param {String} event
    */
    protected eventFormulario(event: string) {  
      /* Se valida la respuesta de la casilla 994 al actualizar el formulario  */
      if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
        this.modelo.doc.pie['cs_id_994'] = false;
      }          
    }

    /**
    * @desc Funcion abstracta que comunica al hijo cuando se ha cargado uno o varios documentos cuando se usa el componente de cargar ficheros
    * @param {Any} docs
    */
    protected onUploadFiles(docs: Array<DArchivoBlob>){

    }    

    // ====== Metodos creados por el desarrollador para operaciones con casillas y otras como (validacionesEnCampos, etc) ======
    private aplicarValidacionZomac(){
      this.anioDeclaracion = Number(this.modelo.doc.cab.cs_id_1);
      if(this.anioDeclaracion >= 2022 && this.anioDeclaracion <= 2027){
        if(this.modelo.doc.cuerpo.cs_id_96 != ""){
          let confirmZomac = this.dNotificacionServicio.
          mostrarDialogoConfirmacion("¿Está sometido al régimen de tributación de las sociedades que desarrollan actividades en las ZOMAC (art. 237 Ley 1819 de 2016) ?"
          +"<br>O está incluido en el Decreto 261 del 24 de febrero de 2023 Artículo 2°. Que sustituye el Artículo 1.2.6.8 del título 6 de la parte 2 del Libro 1 "
          +"del Decreto número 1625 de 2016 Único Reglamentario en Materia Tributaria, en los parágrafos 4, 5 y 6");        
          confirmZomac.afterClosed().subscribe(
            result => {
              if (result) {
                this.modelo.doc.cuerpo.cs_id_101 = '1';
              }else{
                this.modelo.doc.cuerpo.cs_id_101 = '0';
                this.operacionCs67();
              }
            }
          );
        }
      }
    }
    private aplicarValidacionZomac2(){
      this.anioDeclaracion = Number(this.modelo.doc.cab.cs_id_1);
    setTimeout(() => {
          let confirmZomac = this.dNotificacionServicio.
          
            
            mostrarDialogoConfirmacion("¿Está sometido al régimen de tributación de las sociedades que desarrollan actividades en las ZOMAC (art. 237 Ley 1819 de 2016) ?"
              +""
              +"");        
              confirmZomac.afterClosed().subscribe(
                result => {
                  if (result) {
                    this.habilitacion67=true;
                    this.modelo.doc.cuerpo.cs_id_101 = '1';
                  }else{
                    this.habilitacion67=false;
                    this.modelo.doc.cuerpo.cs_id_101 = '0';
                  }
                  this.operacionCs67();
                }
              );
              
            }, 1000);
      
    }

    private consultarActividadesEconomicasConTarifasRetencion(anio: string, periodo:string) {
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dServicioRESTAPI.consultarActividadesEconomicasConTarifasRetencion(anio,periodo)
        .subscribe(
          res => {
            this.listActividadesEconomicas = <Array<DTarifaRetencionActEconomica>>res;
            //Carga la informacion del modelo en el objeto tarifa retencion en la vista
            for (let i in this.listActividadesEconomicas) {
              if (this.listActividadesEconomicas[i].codCiiu === this.modelo.doc.cuerpo.cs_id_96) {      
                let resultado = Number(this.modelo.doc.cuerpo.cs_id_97) / 100;
                if (String(resultado) === this.listActividadesEconomicas[i].valTarifa) this.tarifaRetencion = this.listActividadesEconomicas[i];
                break;
              }
            }
            precargaProceso.close();
          }, 
          error => {
            precargaProceso.close();
            this.dNotificacionServicio.mostrarDialogoError('Error obteniendo las actividades economicas y las tarifas de retención', error.mensaje);
          }
        );
    }

    /**
    * @desc Funcion que obtiene las actividades economicas del contribuyente para que sean renderizadas en la vista
    * @param {String} nit
    */
    private obtenerActividadesEconomicas(nit:string) {
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dRutServicios.consultarActividadesEconomicasContribuyente(nit);    
        observableServicio.subscribe(
            res => {
                this.actividadesEconomicas = <DActividadesEconomicas>res;  
                precargaProceso.close();        
            },                
            error =>{  
                precargaProceso.close();
                this.dNotificacionServicio.mostrarDialogoError("Se presentó un error en la consulta de actividad económica.");                   
            }
        );
    }

    /**
    * @desc Funcion para calcular casilla 67
    */
    private operacionCs67():void { 
      if(this.modelo.doc.cuerpo.cs_id_101 == '1'){
        this.habilitacion67 = true;
      }else{
        this.habilitacion67 = false;
      }
      let cas42 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_42, true); 
      let cas97 = //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, this.modelo.doc.cuerpo.cs_id_97, '100', false);
      Number(this.modelo.doc.cuerpo.cs_id_97) / 100;
      let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas42, String(cas97), false);
      //let resultadoPorcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, resultadoMultiplicacion, "100", true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoMultiplicacion, "0" ) ? "0" : resultadoMultiplicacion;
      this.modelo.doc.cuerpo.cs_id_67 = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
      this.operacionCs78();
    } 

    /**
    * @desc Funcion para calcular casilla 78
    */
    private operacionCs78():void { 
      let campos = ['cs_id_52','cs_id_53','cs_id_54','cs_id_55','cs_id_56','cs_id_57','cs_id_58','cs_id_59','cs_id_60','cs_id_61','cs_id_62','cs_id_63',
      'cs_id_64','cs_id_65','cs_id_66','cs_id_67','cs_id_68','cs_id_69','cs_id_70','cs_id_71','cs_id_72','cs_id_73','cs_id_74','cs_id_75','cs_id_76'];
      let cas77 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_77);
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas77, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_78 = String(valorRedondeado);
      this.operacionCs85();
    } 

    /**
    * @desc Funcion para calcular casilla 82
    */
    private operacionCs82():void { 
      let campos = ['cs_id_79','cs_id_80'];
      let cas81 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_81);
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas81, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_82 = String(valorRedondeado);
      this.operacionCs85();
    }

    /**
    * @desc Funcion para calcular casilla 85
    */
    private operacionCs85():void { 
      let campos = ['cs_id_78','cs_id_82','cs_id_83','cs_id_84'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_85 = String(valorRedondeado);
      this.operacionCs87();
    }

    /**
    * @desc Funcion para calcular casilla 87
    */
    private operacionCs87():void { 
      let campos = ['cs_id_85','cs_id_86'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_87 = String(valorRedondeado);
    }

    /**
    * @desc Funcion casilla los valores de los conceptos para poner en la casilla 50 y 75
    * @param {Array<DConceptoPago>} listConceptos
    */    
    public calcularValorConceptos50y75(listConceptos: Array<DConceptoPago>) {
      let valores = this.obtenerSumaTotalConceptos(listConceptos);      
      this.modelo.doc.cuerpo.cs_id_50 = valores[0]; 
      this.modelo.doc.cuerpo.cs_id_75 = valores[1];
      this.listConceptosCs50y75 = listConceptos;
      this.operacionCs78();
    }

    /**
    * @desc Funcion casilla los valores de los conceptos para poner en la casilla 51 y 76
    * @param {Array<DConceptoPago>} listConceptos
    */    
    public calcularValorConceptos51y76(listConceptos: Array<DConceptoPago>) {
      let valores = this.obtenerSumaTotalConceptos(listConceptos);
      this.modelo.doc.cuerpo.cs_id_51 = valores[0];
      this.modelo.doc.cuerpo.cs_id_76 = valores[1];
      this.listConceptosCs51y76 = listConceptos;      
      this.operacionCs78();
    }

    /**
    * @desc Funcion para cuando se selecciona una tarifa de retención validar si el contribuyente tiene la actividad asociada en su RUT
    */
    public seleccionarTarifaRetencion() {
      let bandera = false;
      if(!this.tarifaRetencion){
        this.modelo.doc.cuerpo.cs_id_97 = "";
        this.modelo.doc.cuerpo.cs_id_42 = "0";
        this.modelo.doc.cuerpo.cs_id_67 = "0";
      }
      else{
      for (let i in this.actividadesEconomicas) {  
        if (this.actividadesEconomicas[i].id == this.tarifaRetencion.codCiiu) bandera = true;
      }

      if (bandera) {
        this.modelo.doc.cuerpo.cs_id_96 = this.tarifaRetencion.codCiiu;
        let porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.tarifaRetencion.valTarifa, '100', true);
        this.modelo.doc.cuerpo.cs_id_97 = String(porcentaje);
        this.operacionCs67();
      } else {
        this.tarifaRetencion = new DTarifaRetencionActEconomica();
        this.modelo.doc.cuerpo.cs_id_96 = "";
        this.modelo.doc.cuerpo.cs_id_97 = "";
        this.operacionCs67();
        this.dNotificacionServicio.mostrarDialogoInformacion("Si es autorretenedor de los considerados en decreto 2201 de 2016 debe seleccionar la actividad econ&oacute;mica principal. Recuerde que si tiene registrada al menos una las actividades contempladas por el decreto 2201 debe actualizar el RUT.");
      } 
      
    }
  }

    /**
    * @desc Funcion casilla 85 para obtener el DV
    */
    public obtenerDVSignatario() {      
      if (this.modelo.doc.cuerpo.cs_id_88) {
        let valor88 = this.modelo.doc.cuerpo.cs_id_88.trim();
        let dv = String(this.utilitariosForm.calcularDV(valor88));
        this.modelo.doc.cuerpo.cs_id_89 = valor88 ? dv : "";
        this.modelo.doc.cuerpo.cs_id_88 = valor88;  
      } else {
         this.modelo.doc.cuerpo.cs_id_88 = "";       
      }
    }

    /**
    * @desc Funcion que realiza la suma de los totales de los conceptos
    * @param {Array<DConceptoPago>} listConceptos
    * @return {Array<string>}
    */
    private obtenerSumaTotalConceptos(listConceptos: Array<DConceptoPago>): Array<string> {
      let sumaBaseConceptos: string = "0";
      let sumaRetConceptos: string = "0";
      
      for (let i in listConceptos) {
        sumaBaseConceptos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaBaseConceptos, this.dutilidades.redondearValorMoneda(listConceptos[i].subTotalBases), true);
        sumaRetConceptos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sumaRetConceptos, this.dutilidades.redondearValorMoneda(listConceptos[i].subTotalRetencion), true);        
      }
      return [sumaBaseConceptos, sumaRetConceptos];
    }

    /**
    * @desc Funcion que mapea el objeto tipo lista que se arma de los conceptos al array del modelo antes de 
    * guardar o actualizar o realizar un definitivo
    */
    public transformarListaAModeloCasillas(operacion: string) {
      this.prepararCasillas();  
      let arrConceptos = [
        { convenio: false, data: this.listConceptosCs50y75 },
        { convenio: true, data: this.listConceptosCs51y76 }
      ];

      for (let i in arrConceptos) {
        this.transformarDocumento(arrConceptos[i].data, arrConceptos[i].convenio)
      }      

      if (this.modelo.doc.cuerpo.cs_id_97 == "0") {
        this.modelo.doc.cuerpo.cs_id_96 = "";      
        this.modelo.doc.cuerpo.cs_id_97 = "";
      }

      if (!this.modelo.doc.cuerpo.cs_id_88) {
        this.modelo.doc.cuerpo.cs_id_88 = "";      
        this.modelo.doc.cuerpo.cs_id_89 = "";
      }

      //Validar retenciones
      //if (!this.validarRetenciones()) {
      switch (operacion) {
        case 'guardarActualizar':
          this.guardarActualizarBorrador();
          break;
        case 'definitivo':
          this.guardarFormularioDefinitivo();
          break;
      }
      //}      
    }

    /**
    * @desc Funcion que valida la casilla si tiene retencion para dejarlo continuar con el proceso
    */
    private validarRetenciones(): boolean {      
      let mapaValidaciones = [
        {
          base: 'cs_id_27',
          retencion: 'cs_id_52'
        },
        {
          base: 'cs_id_28',
          retencion: 'cs_id_53'
        },
        {
          base: 'cs_id_29',
          retencion: 'cs_id_54'
        },
        {
          base: 'cs_id_30',
          retencion: 'cs_id_55'
        },
        {
          base: 'cs_id_31',
          retencion: 'cs_id_56'
        },
        {
          base: 'cs_id_32',
          retencion: 'cs_id_57'
        },
        {
          base: 'cs_id_33',
          retencion: 'cs_id_58'
        },
        {
          base: 'cs_id_34',
          retencion: 'cs_id_59'
        },
        {
          base: 'cs_id_35',
          retencion: 'cs_id_60'
        },
        {
          base: 'cs_id_36',
          retencion: 'cs_id_61'
        },
        {
          base: 'cs_id_37',
          retencion: 'cs_id_62'
        },
        {
          base: 'cs_id_38',
          retencion: 'cs_id_63'
        },
        {
          base: 'cs_id_39',
          retencion: 'cs_id_64'
        },
        {
          base: 'cs_id_40',
          retencion: 'cs_id_65'
        },
        {
          base: 'cs_id_41',
          retencion: 'cs_id_66'
        },
        {
          base: 'cs_id_42',
          retencion: 'cs_id_67'
        },
        {
          base: 'cs_id_43',
          retencion: 'cs_id_68'
        },
        {
          base: 'cs_id_44',
          retencion: 'cs_id_69'
        },
        {
          base: 'cs_id_45',
          retencion: 'cs_id_70'
        },
        {
          base: 'cs_id_46',
          retencion: 'cs_id_71'
        },
        {
          base: 'cs_id_47',
          retencion: 'cs_id_72'
        },
        {
          base: 'cs_id_48',
          retencion: 'cs_id_73'
        },
        {
          base: 'cs_id_49',
          retencion: 'cs_id_74'
        }
      ];
      let bandera = false;
      let casBase = "";
      let casRetencion = "";

      for (let i in mapaValidaciones) {
        let base = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo[mapaValidaciones[i].base]);
        let retencion = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo[mapaValidaciones[i].retencion]);
        
        if (Number(base) > 0 && Number(retencion) === 0) {
          casBase = mapaValidaciones[i].base;
          casRetencion = mapaValidaciones[i].retencion;
          bandera = true;
          break;
        }
      }

      if (bandera) {
        this.dNotificacionServicio.mostrarDialogoInformacion("La base de la casilla: " + casBase.replace(/[^0-9]/g,'') + " no tiene una retención para la casilla: " + casRetencion.replace(/[^0-9]/g,'') + " Asegurese de haber llenado las casillas correctamente.");
      } 
      return bandera;     

    }

    /**
    * @desc Funcion que transforma el documento en el requerido por el servicio
    * @param {Array<DConceptoPago>}
    * @param {Boolean} convenio
    */
    private transformarDocumento(list: Array<DConceptoPago>, convenio: boolean) {         
      if (list.length) {
        for (let i in list) {
          let ultimoIndice = this.modelo.doc.cuerpo['cc_id_90'];
          let index = ultimoIndice.length ? ultimoIndice[ultimoIndice.length - 1].it + 1 : 1;

          let itemsConcepto = <Array<DItemConcepto>>list[i].items;
          if (itemsConcepto.length) {                    
            for (let c in itemsConcepto) {
              let cc90 = {'it': index, 'v': itemsConcepto[c].cc_id_90 ? itemsConcepto[c].cc_id_90 : null};
              let cc91 = {'it': index, 'v': itemsConcepto[c].cc_id_91 ? itemsConcepto[c].cc_id_91 : null};
              let cc92 = {'it': index, 'v': itemsConcepto[c].cc_id_92 ? itemsConcepto[c].cc_id_92.codigoNum : null};
              let cc93 = {'it': index, 'v': itemsConcepto[c].cc_id_93 ? this.dutilidades.deshacerFormatoMoneda(itemsConcepto[c].cc_id_93) : null};
              let cc94 = {'it': index, 'v': itemsConcepto[c].cc_id_94 ? this.dutilidades.deshacerFormatoMoneda(itemsConcepto[c].cc_id_94) : null};
              let cc95 = {'it': index, 'v': itemsConcepto[c].cc_id_95 ? this.dutilidades.deshacerFormatoMoneda(itemsConcepto[c].cc_id_95) : null};              
              this.modelo.doc.cuerpo['cc_id_90'].push(cc90);
              this.modelo.doc.cuerpo['cc_id_91'].push(cc91);
              this.modelo.doc.cuerpo['cc_id_92'].push(cc92);
              this.modelo.doc.cuerpo['cc_id_93'].push(cc93);
              this.modelo.doc.cuerpo['cc_id_94'].push(cc94);
              this.modelo.doc.cuerpo['cc_id_95'].push(cc95);              
              index++;
            }
          }
          //Meter totales (Descomentar si se require llenar la tercera hoja)
          /*this.modelo.doc.cuerpo.cc_id_98.push(convenio ? '1' : '0');
          this.modelo.doc.cuerpo.cc_id_99.push(list[i].id);
          this.modelo.doc.cuerpo.cc_id_100.push(list[i].subTotalBases);
          this.modelo.doc.cuerpo.cc_id_101.push(list[i].subTotalRetencion);*/
        }
      };
    }    

    /**
    * @desc Funcion que inicializa las casilas en tipo array
    */
    private prepararCasillas() {
      this.modelo.doc.cuerpo['cc_id_90'] = new Array<any>();
      this.modelo.doc.cuerpo['cc_id_91'] = new Array<any>();
      this.modelo.doc.cuerpo['cc_id_92'] = new Array<any>();
      this.modelo.doc.cuerpo['cc_id_93'] = new Array<any>();
      this.modelo.doc.cuerpo['cc_id_94'] = new Array<any>();
      this.modelo.doc.cuerpo['cc_id_95'] = new Array<any>();
      //Meter totales (Descomentar si se require llenar la tercera hoja)
      /*this.modelo.doc.cuerpo.cc_id_98 = new Array<string>();
      this.modelo.doc.cuerpo.cc_id_99 = new Array<string>();
      this.modelo.doc.cuerpo.cc_id_100 = new Array<string>();
      this.modelo.doc.cuerpo.cc_id_101 = new Array<string>();*/
    }

    /**
    * @desc Funcion para validar los datos de la casilla anterior y si es mayor o no
    * @param {Any} casAnterior
    * @param {Any} casActual    
    * @param {Boolean} casAnteriorMayor
    */
    public validarCasillaAnterior(casAnterior: any, casActual: any, casActualMayor: boolean) {
      let casAntEl = casAnterior as HTMLInputElement;
      let casActEL = casActual as HTMLInputElement;
      let casAnt = this.modelo.doc.cuerpo[casAntEl.id];
      let casAct = this.modelo.doc.cuerpo[casActEL.id];

      let extraccionNumeros = casAntEl.id.match(/\d/g);
      let numeroCasilla = extraccionNumeros.join("");

      if (!casAnt) this.dNotificacionServicio.mostrarDialogoInformacion("Debe diligenciar primero la casilla " + numeroCasilla);

      if (!casActualMayor) {
        let menorQue = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, casAct, casAnt);
        let iguales = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, casAct, casAnt);        
        if (!menorQue && !iguales) {
          this.modelo.doc.cuerpo[casActEL.id] = "0";
          this.dNotificacionServicio.mostrarDialogoInformacion("El valor de la base no puede ser menor a la retención");
        }
      }
    }
    public multiplicarTarifa( tarifa :string)
    {
      let valTarifa = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, tarifa, '100', true);
      return valTarifa;
    }

}



// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/formulario/formulario/formulario.component.ts